<template>
  <AttrGroup
    title="自动布局"
    :show-add="!flexEnabled"
    :show-delete="flexEnabled"
    @add="() => onShowToggle(true)"
    @delete="() => onShowToggle(false)"
  >
    <div v-if="flexEnabled" class="flex mt-2.5 gap-2.5">
      <div class="flex-1">
        <div
          :class="{
            ' opacity-30': !!attrDisabled
          }"
        >
          <div class="flex gap-2.5">
            <div
              v-for="dir in dirOptions"
              :key="dir.value"
              class="w-1/2 h-[52px] rounded-lg flex justify-center items-center"
              :class="{
                'bg-[#595959]': shape.attrs.flexDirection === dir.value,
                'bg-[#313131]': shape.attrs.flexDirection !== dir.value
              }"
              @click="
                () =>
                  !attrDisabled && shape.setAttrs({ flexDirection: dir.value })
              "
            >
              <icon :icon="dir.icon" fill="none" :width="20" />
            </div>
          </div>
        </div>
        <div class="mt-2.5">
          <AttrInputNumber
            label="间距"
            :value="shape.attrs.gap"
            class="w-full"
            :disabled="!!attrDisabled"
            :precision="0"
            :min="canUse('widget-gap-negative').valid ? -127 : 0"
            :max="127"
            @change="changGap"
          />
        </div>
      </div>
      <div>
        <div class="_grid">
          <template v-for="minor in flexItems" :key="minor.align">
            <div
              v-for="primary in flexItems"
              :key="primary.align"
              class="flex justify-center items-center relative"
              :class="{
                _horver: horverd == primary.align + minor.align,
                _active:
                  shape.attrs.flexDirection == 'row'
                    ? shape.attrs.justifyContent == primary.align &&
                      shape.attrs.alignItems == minor.align
                    : shape.attrs.justifyContent == minor.align &&
                      shape.attrs.alignItems == primary.align
              }"
              @click="
                () => !attrDisabled && onChangeFlex(primary.align, minor.align)
              "
              @mouseenter="() => (horverd = primary.align + minor.align)"
              @mouseleave="() => (horverd = '')"
            >
              <!-- 对齐标志 -->
              <div
                class="flex w-5 h-5 opacity-0 _bar"
                :class="{
                  'flex-col': shape.attrs.flexDirection == 'column',
                  'items-start':
                    (shape.attrs.flexDirection == 'row'
                      ? minor.align
                      : primary.align) == 'flex-start',
                  'items-center':
                    (shape.attrs.flexDirection == 'row'
                      ? minor.align
                      : primary.align) == 'center',
                  'items-end':
                    (shape.attrs.flexDirection == 'row'
                      ? minor.align
                      : primary.align) == 'flex-end'
                }"
              >
                <template v-if="shape.attrs.flexDirection == 'row'">
                  <div
                    v-for="i in 3"
                    :key="i"
                    class="w-[4px] _item"
                    :class="{
                      'mx-[2px]': i == 2
                    }"
                    :style="{
                      height: i == 1 ? '14px' : i == 2 ? '20px' : '10px'
                    }"
                  />
                </template>
                <template v-if="shape.attrs.flexDirection == 'column'">
                  <div
                    v-for="i in 3"
                    :key="i"
                    class="h-[4px] _item"
                    :class="{
                      'my-[2px]': i == 2
                    }"
                    :style="{
                      width: i == 1 ? '14px' : i == 2 ? '20px' : '10px'
                    }"
                  />
                </template>
              </div>
              <!-- dot -->
              <div
                class="w-[6px] h-[6px] rounded-lg bg-[#FFF]/[0.3] absolute _dot"
              />
            </div>
          </template>
        </div>
      </div>
    </div>
  </AttrGroup>
</template>

<script lang="ts" setup>
import { ref, PropType, computed } from 'vue';
import { Shape } from '@/services/shape';
import { useEditorStore } from '@/store/use-editor-store';
import { WidgetAttribute } from '@/services/shape/attributes/widget';
import { canUse } from '@/utils/can-use.utils';
const props = defineProps({
  shape: {
    type: Object as PropType<Shape>,
    required: true
  }
});
const flexEnabled = computed(() => {
  const flexDirection = props.shape.attrs.flexDirection;
  return flexDirection == 'column' || flexDirection == 'row';
});
const dirOptions: {
  value: WidgetAttribute['flexDirection'];
  icon: string;
}[] = [
  {
    value: 'column',
    icon: 'arrow-down2.svg'
  },
  {
    value: 'row',
    icon: 'arrow-right2.svg'
  }
];

const editorStore = useEditorStore();
const attrDisabled = computed(() => editorStore.attrDisabled);

const flexItems: {
  align: WidgetAttribute['justifyContent'];
  row: string;
  column: string;
}[] = [
  { align: 'flex-start', row: '顶部', column: '左对齐' },
  { align: 'center', row: '水平', column: '居中对齐' },
  { align: 'flex-end', row: '底部', column: '右对齐' }
];
const horverd = ref('');
// const resetChildren = () => {

// };

const onShowToggle = (status: boolean) => {
  if (attrDisabled.value) return;
  props.shape.setAttrs({
    flexDirection: status ? 'column' : 'disabled',
    justifyContent: props.shape.attrs.justifyContent ?? 'flex-start',
    alignItems: props.shape.attrs.alignItems ?? 'flex-start',
    gap: props.shape.attrs.gap ?? 0
  });
  props.shape.reverseChildren();
};

const changGap = (v: number) => {
  props.shape.setAttrs({
    gap: v
  });
};

const onChangeFlex = (
  primary: WidgetAttribute['justifyContent'],
  minor: WidgetAttribute['justifyContent']
) => {
  const _primary = props.shape.attrs.flexDirection == 'row' ? primary : minor;
  const _minor = props.shape.attrs.flexDirection == 'row' ? minor : primary;
  props.shape.setAttrs({
    justifyContent: _primary,
    alignItems: _minor
  });
};
</script>

<style lang="less" scoped>
._grid {
  display: grid;
  width: 114px;
  height: 114px;
  padding: 17px;
  gap: 10px;
  grid-template-columns: repeat(3, 1fr);
  background-color: #313131;
  border-radius: 8px;

  ._item {
    background: rgba(0, 148, 255, 0.5);
    border-radius: 4px;
  }
  ._active {
    ._item {
      background: rgba(0, 148, 255, 1);
    }
  }
  ._active,
  ._horver {
    ._bar {
      opacity: 100;
    }
    ._dot {
      opacity: 0;
    }
  }
}
</style>
